/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class RequestStateIds {
    static readonly new: string = "d0cd6886-f766-4eb0-ae03-0c85ce7a959d";
    static readonly inProgress: string = "13a2456e-7478-44e8-9d2f-37ef73762505";
    static readonly closedIncomplete: string = "84e6246b-40a4-4390-ba11-b65d452fc693";
    static readonly closedComplete: string = "7416f9aa-3a26-41d7-b4b0-4499c8806058";
    static inProgressStates: string[] = ["13a2456e-7478-44e8-9d2f-37ef73762505"];
}
